<template>
    <div class="d-flex">
        <div class="col-md-3">
            <panelPrice :selectedEnterprise="selectedEnterprise"></panelPrice>
        </div>
        <div class="col-md-9">
            <b-tabs v-model="tabIndex">
                <b-tab
                    :title="'Tabela de preços'">
                    <div class="mt-2"></div>
                    <template slot="title">
                        <div>
                            <span class="d-md-down-none pl-1 text-tabs">Tabela de preços</span>
                        </div>
                    </template>
                    <div class="tamanhopagTab">
                        <Mirrorsalesenterprise
                            :title="'Detalhe da Tabela de Preços'"
                            :dataEnterprise="selectedEnterprise">
                        </Mirrorsalesenterprise>
                    </div>
                </b-tab>
                <b-tab class="tamanhopagLog" :title="'Log'">
                    <HeadDetailsGama
                        :titleHead="'Detalhe da Tabela de Preços'">
                    </HeadDetailsGama>
                    <div class = "mt-5 log">
                        <compLog :dataLog="dataLog" ></compLog>
                    </div>
                    <template slot="title">
                        <div>
                            <span class="d-md-down-none pl-1 text-tabs">Log</span>
                        </div>
                    </template>
                </b-tab>
            </b-tabs>
            <b-modal
                hide-footer
                size="x5"
                centered
                ref="add-user-modal"
                id="add-user-modal"
                title="ADICIONAR NOVA TABELA"
                >
                <template #modal-title>
                    <div class="header-title">ADICIONAR IMAGEM E PDF</div>
                </template>
                <div class="modal-body-ex h-100 w-100">
                    <div class="quadradoBackground">
                        <div class="cloudUp">
                            <i class="fas fa-cloud-upload-alt fa-4x" aria-hidden="true"></i>
                        </div>
                        <label
                            class="labelf" for="arquivo">IMPORTE UM ARQUIVO EXCEL
                        </label>
                        <input
                            class="inputf" type="file" id="arquivo">
                        <label
                            class="customArchive">ou solte o arquivo aqui
                        </label>
                        <fileUploaderPrice></fileUploaderPrice>
                    </div>
                </div>
                <div class="buttonType mt-5">
                    <button v-on:click="closeTemplatePriceFather" class="buttonStyle">CANCELAR</button>
                    <button class="buttonStyle">ADICIONAR</button>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script scoped>
import detailsPrice from './detailsPrice'
export default detailsPrice
</script>

<style scoped>
.header-title{
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}
.tamanhopagTab
{
    height: 100%;
    width: auto;
    min-height: 620px;
}
.tamanhopagLog
{
    height: 100%;
    width: auto;
    min-height: 660px;
    overflow-y: auto;
}
.customArchive{
   font-weight: bold;
   color:rgb(177, 166, 166);
   text-align: center;
   width: 100%;
}
.custom-file-label{
    margin-top: 100px;
    width: 70%;
    height: 500%;
    display: none;
}

#img-pincipal{
    height: 100%;
    width: 100%;
    object-fit: cover;
}

#body-details{
    height: 60vh;
    overflow: auto;
}

.subtitle {
    font-size: 18px;
    color: #008148;
    font-weight: bold;
}

.input-details{
    width: 100%;
    height: 35px;
    background-color: #F1F1F1;
    border: 1px solid #D4D9DE;
    border-radius: 5px;
}
.aprtamento{
    font-size:20px;
}
.label-details{
    font-size: 15px;
    color: black;
    margin-bottom: 0px;

}
.result-details{
    font-size: 16px;
    font-weight: bold;

}
.text-tabs{
    color: #008148;
}
#body-details{
    height: 60vh;
}
#head-details{
  display: flex;
  justify-content: space-between;
}
.input-rela{
  position: relative;
}
.head-right {
  height: 59px;
  display: flex;
  width: 100%;
  background: #ECEFF1 0% 0% no-repeat padding-box;
  border: 1px solid #CFD8DC;
  border-radius: 4px 4px 0px 0px;
  opacity: 1;
}
.btn-new-gru{
  height: 30px;
  width: 181px;
  background: white;
  font-size: 14px;
  color: #008148;
  font-weight: bold;
  border: 1px solid #008148;
  margin: 0px;
  border-radius: 6px;
}
.title-left{
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}
.title-colapse-mirror{
    font-weight: bold;
    font-size: 20px;
}
.arrow-angel{
  font-size: 30px;
  padding-top: 0px;
  color: black;
  padding-right: 20px !important;
  padding-bottom: 10px !important;
}
.btn-new-gru:hover{
  color: white;
  background: #008148;
}

#details-board{
    height: 80vh;
    width: 100%;
    background-color:white;
}

#card-details{
    width: 100%;
    border: 1px solid rgb(202, 202, 202);
    background-color: white;
    border-radius: 5px;
}

#footer-card-details{
    display: flex;
    font-size: 35px;
}

#nameTower{
    color: rgb(90, 90, 90);
    font-size: 30px;
    font-weight: bold;
}

#card-img{
    height: 250px;
}
/* novo */

.inputIcon{
    position:relative;
}

.inputIcon i{
    position: absolute;
    left:0;
    top:8px;
    padding:4px 10px;
}

#info{
    height: 50px;
    width: 100%;
    font-size: 22px;
    background-color: #008148;
    padding-top: 15px;
    color: white;
}

hr{
    width: 95%;
}

.container-user-form{
    display: grid;
    column-gap: 10px;
    row-gap: 10px;
    justify-content: center;
    grid-template-rows: 10% 1fr 1fr 10% 1fr 1fr;
    grid-template-columns: repeat(10,1fr);
}

.inputf[type="file"] {
    display: none;
}

.labelf{
    width: 220px;
    height: 32px;
    margin-left:18%;
    background: #fff;
    color:rgb(177, 166, 166);
    display: block;
    margin-top: 22%;
    font-family: Arial, Helvetica, sans-serif;
    text-align:center;
    cursor: pointer;
    transition: .2s;
    font-weight: bold;
    border: 1px solid rgb(204, 195, 195);
    border-radius: 5px 5px 5px;
    padding-top: 4px;
}

.labelf:hover{
    color: #fff;
    background: #008148;
}

.quadradoBackground{
    width: 350px;
    height: 150px;
    background: rgb(248, 245, 245);
    border: 1px rgb(206, 197, 197) dashed;
    color: rgb(204, 195, 195);
    border-radius:3px 3px;

}
.modal-body-ex{
    display: flex;
    justify-content: center;
    align-content: center;
}

.lb2{
   font-weight: bold;
   color:rgb(177, 166, 166);
   text-align: center;
   width: 100%;
}

.cloudUp{
    color:rgb(204, 195, 195);
    position:absolute;
    margin-left:27%;
    margin-top:3%;
}

.buttonType{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:20px;

}

.buttonStyle{
    border:transparent;
    align-items: center;
    font-weight: bold;
    color: rgb(65, 62, 62);
    background:rgb(204, 195, 195);
    transition: .2s;
    height: 35px;
    width: 168px;
    font-family: Arial, Helvetica, sans-serif;
    text-align:center;
    border-radius: 5px 5px;
}

.buttonStyle:hover{
    color: #fff;
    background: #008148;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/pricetablemanagement/components/detailsPrice/detailsPrice.vue